import { useTheme } from '@mui/material';

import { Button, Icons, Typography, Stack, tokens } from '@cast/design-system';

type InstallComponentFallbackProps = {
  message: string;
  refetch?: () => void;
  testId?: string;
};

export const InstallComponentFallback = ({
  message,
  refetch,
  testId = 'install-agent-fallback',
}: InstallComponentFallbackProps) => {
  const { palette } = useTheme();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      sx={{ border: tokens.theme.border.status.error, borderRadius: '4px' }}
      p="8px 12px"
      className="InstallAgentFallback-Root"
      data-testid={testId}
    >
      <Stack direction="row" alignItems="center" gap="4px">
        <Icons.XCircle color={palette.red[500]} weight="fill" />
        <Typography variant="P12M">{message}</Typography>
      </Stack>
      {!!refetch && (
        <Button
          variant="text"
          endIcon={<Icons.ArrowsCounterClockwise />}
          onClick={refetch}
          testId="refetch-button"
        >
          Refetch
        </Button>
      )}
    </Stack>
  );
};
